import { keyToActionTypes } from 'src/utils/keyToActionTypes';

export const appActionTypes: any = keyToActionTypes(
  {
    LOAD_ROLES: null,
    ROLES_LOADED: null,
    ROLES_ERROR: null,
    UPDATE_CONFIG: null,
    CONFIG_ERROR: null,
    UPDATE_LANGUAGE: null,
    LANGUAGE_ERROR: null,
    UPDATE_DATE_RANGE: null,
    ROUTE_CHANGE: null,
  },
  'APP'
);